import { render, staticRenderFns } from "./LoginOasys.vue?vue&type=template&id=189aa740&scoped=true"
import script from "./LoginOasys.vue?vue&type=script&lang=js"
export * from "./LoginOasys.vue?vue&type=script&lang=js"
import style0 from "./LoginOasys.vue?vue&type=style&index=0&id=189aa740&prod&scoped=true&lang=css"
import style1 from "./LoginOasys.vue?vue&type=style&index=1&id=189aa740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aa740",
  null
  
)

export default component.exports